module.exports = __webpack_public_path__ + "static/img/shilitu@2x.416d0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/shilitu@2x.png
// module id = aiiA
// module chunks = 70